import type { Database } from 'sql.js';
import { queryOne, rowFirstKeyColumn as rowCol, sqlPositiveIntId } from './sqljsSqlitePrimitives.ts';

/** Resolves `participantes.tipo_bono_id` (master sync catalog hint for `bonos` auto-create). */
export function participanteTipoBonoCatalogId(db: Database, participanteId: number): number | null {
  if (!Number.isFinite(participanteId) || participanteId <= 0) return null;
  const row = queryOne(db, 'SELECT tipo_bono_id FROM participantes WHERE id = ?', [participanteId]);
  return sqlPositiveIntId(row?.tipo_bono_id ?? row?.TIPO_BONO_ID);
}

/** Resolves `tipos_bonos.nombre` for a catalog row id (master sync / legacy FK backfill). */
export function lookupTipoBonoNombreById(db: Database, tipoBonoId: number | null | undefined): string | null {
  const id = sqlPositiveIntId(tipoBonoId);
  if (id == null) return null;
  if (queryOne(db, `SELECT 1 FROM sqlite_master WHERE type='table' AND name='tipos_bonos'`, []) == null) {
    return null;
  }
  const row = queryOne(db, `SELECT nombre FROM tipos_bonos WHERE id = ?`, [id]);
  if (!row) return null;
  const nombre = String(rowCol(row, 'nombre', 'NOMBRE') ?? '').trim();
  return nombre.length > 0 ? nombre : null;
}

/** Reads free-text `tipo_bono` from a PEP/RBP row, falling back to legacy `tipo_bono_id` when present. */
export function captureTipoBonoTextFromSqlRow(
  db: Database,
  row: Record<string, unknown>,
): string {
  const direct = String(row.tipo_bono ?? row.TIPO_BONO ?? '').trim();
  if (direct.length > 0) return direct;
  const legacyId = sqlPositiveIntId(row.tipo_bono_id ?? row.TIPO_BONO_ID);
  return lookupTipoBonoNombreById(db, legacyId) ?? '';
}
